import * as React from 'react';
// @ts-expect-error
import {DragLayer} from 'react-dnd';

import {dragItemTypes} from './drag-item-types';
import type {DragItem} from './drag-item-types';
// @ts-expect-error
import ColumnDragPreview from './drag-previews/preview-column-header';
import {PreviewLeadCard} from './drag-previews/preview-lead-card';

const layerStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
} as const;

// @ts-expect-error
function getItemStyles(initialOffset, currentOffset) {
    if (!initialOffset || !currentOffset) {
        return {
            display: 'none',
        };
    }

    const {x, y} = currentOffset;

    const transform = `translate(${x}px, ${y}px)`;

    return {
        transform: transform,
        WebkitTransform: transform,
    };
}

/*
This helper function is used to convert the results of monitor calls
into a `DragItem` type which we can reliably switch on inside `renderItem`.
Basically, it's just so we can get flow to be happy without updating flow-typed
definitions for react-dnd.
 */
// @ts-expect-error
function getDragItem(monitor): DragItem {
    const type = monitor.getItemType() as any;
    const item = monitor.getItem() as any;

    return {type, item};
}

// @ts-expect-error
function collect(monitor) {
    return {
        dragItem: getDragItem(monitor),
        initialOffset: monitor.getInitialSourceClientOffset(),
        currentOffset: monitor.getSourceClientOffset(),
        isDragging: monitor.isDragging(),
    };
}

type Props = {
    dragItem: DragItem;
    initialOffset:
        | {
              x: number;
              y: number;
          }
        | null
        | undefined;
    currentOffset:
        | {
              x: number;
              y: number;
          }
        | null
        | undefined;
    isDragging: boolean;
};

class CustomDragLayer extends React.Component<Props> {
    // @ts-expect-error
    renderItem(dragItem) {
        switch (dragItem.type) {
            case dragItemTypes.LIST_COLUMN:
                return (
                    <ColumnDragPreview
                        title={dragItem.item.title}
                        type={dragItem.item.type}
                        width={dragItem.item.width}
                    />
                );
            case dragItemTypes.LEAD_CARD:
                return (
                    <PreviewLeadCard
                        listItem={dragItem.item.listItem}
                        fieldsToDisplay={dragItem.item.fieldsToDisplay}
                    />
                );
        }
    }

    render() {
        const {dragItem, isDragging} = this.props;

        if (!isDragging) return null;

        return (
            <div style={layerStyles}>
                <div style={getItemStyles(this.props.initialOffset, this.props.currentOffset)}>
                    {this.renderItem(dragItem)}
                </div>
            </div>
        );
    }
}

export default DragLayer(collect)(CustomDragLayer);
